<div class="contract-finance " [class.isFinanceBlockHidden]="hideFinanceBlock === true">
  <div class="contract-finance-title" 
    (click)="isFinanceBlockAvailable? hideFinanceBlock=!hideFinanceBlock : null">
    {{'CONTRACTS.CARD.CONTRACT_ACCONT'|translate}} 
    <mat-icon  class="black-icon" style="width: 18px;" [svgIcon]="hideFinanceBlock? 'arrow-down-s-line' : 'arrow-up-s-line'"> </mat-icon>
  </div>
  <ng-template #loadingTemplate>
    <app-component-loading [size]="'inline'" [margin]="'20px'" *ngIf="isFinanceBlockAvailable"></app-component-loading>
  </ng-template>
  <ng-container *ngIf="isFinanceBlockAvailable && financeData; else loadingTemplate">
    <div class="contract-finance-data" *ngIf="financeData"
      [class.isFinanceBlockHidden]="hideFinanceBlock === true" >
        <div class="contract-finance-data-item" >
            <span class="contract-finance-data-item-label">{{'CONTRACTS.CARD.ACCONT_BALANCE'|translate}}</span>
            <span class="contract-finance-data-item-sum balance">{{financeData.wallet?.wallet?.total  | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru'  }}</span>
        </div>
        
        <div class="contract-finance-data-item">
            <span class="contract-finance-data-item-label">{{'CONTRACTS.CARD.ACCONT_INCOMING'|translate}}</span>
            <span class="contract-finance-data-item-sum incoming"> 
              {{
                ((financeData.currentForecast?.incoming_approved_total||0) + (financeData.currentForecast?.incoming_promised_total||0))
                  | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' 
              }}
            </span>
        </div>
        <div class="contract-finance-data-item">
            <span class="contract-finance-data-item-label">{{'CONTRACTS.CARD.ACCONT_OUTGOING'|translate}}</span>
            <span class="contract-finance-data-item-sum outgoing">
              {{
                ((financeData.currentForecast?.outcoming_approved_total||0) + (financeData.currentForecast?.outcoming_promised_total||0)) 
                | currency : 'RUB' : 'symbol' : '1.2-2' : 'ru' 
              }} 
            </span>
        </div>
    </div>
    <div class="contract-finance-button-block" *ngIf="financeData"
      [class.isFinanceBlockHidden]="hideFinanceBlock === true" >
      <button   (click)=" showTransactions(financeData)" data-action="changeAccount" class="button-icon size-l primary-button"   
        [disabled]="!contractData?.rights?.isCurrentMemberInContract || formState==='Submitting'">
        <mat-icon class="white-icon" svgIcon="wallet-2-fill" style="width: 20px;"> </mat-icon>
        <span> {{'CONTRACTS.CARD.OPEN'|translate}}</span>
      </button>
      <button  (click)="changeAccount(financeData)"  data-action="changeAccount"  class="button-icon size-l outline-button" 
        [disabled]="contractData?.rights?.isCurrentMemberSigner === false ||
                    contractData?.rights?.isContractBlockedForEdit === true ">
        <mat-icon svgIcon="edit-2-fill"></mat-icon>
        <span> {{'CONTRACTS.CARD.EDIT'|translate}} </span>
      </button>
    </div>
  </ng-container>
</div>